import { DEFAULT_DATE_LOCALE, WEEK_FIRST_DAY } from '../../../constants/date'
import { NUMBER_SIZE } from '../../../constants/size'
import { Day } from '../Day'

import { formatWeekDay } from './WeekDay.utils'

import * as styles from './WeekDay.module.css'

/**
 * @typedef {Object} WeekDayComponentProps
 * @property {React.ReactNode} children
 * @property {string} className
 * @property {NumberSize} size
 */

/**
 * @typedef {(day: number, locale: DateLocale) => string} WeekDayFormat
 */

/**
 * @typedef {Object} WeekDayProps
 * @property {React.ComponentType<WeekDayComponentProps>} [Component]
 * @property {string} [className]
 * @property {WeekDayFormat} [format]
 * @property {DateLocale} [locale]
 * @property {NumberSize} [size]
 * @property {number} [value]
 */

/**
 * @param {WeekDayProps} props
 */
function WeekDay({
  Component = Day,
  className = styles.WeekDay,
  format = formatWeekDay,
  locale = DEFAULT_DATE_LOCALE,
  size = NUMBER_SIZE.size40,
  value = WEEK_FIRST_DAY,
  ...componentProps
}) {
  return (
    <Component {...componentProps} className={className} size={size}>
      {format(value, locale)}
    </Component>
  )
}

export default WeekDay
